import * as ACTIONS from "../actions/types"

// A reducer to hold the main data for the survey
// This might not be actually needed...

const defaultState = {
  byID: {},
  allIDs: []
}

const reducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ACTIONS.FETCH_BENEFITS_SUCCESS:
      return {
        ...state,
        byID: payload,
        allIDs: Object.keys(payload)
      }

    case ACTIONS.REPLACE_BENEFITS:
      return {
        ...state,
        byID: payload,
        allIDs: Object.keys(payload)
      }

    default:
      return state
  }
}

export default reducer
